export default __webpack_public_path__ + "static/media/72.4d72ca4b.jpg";